import { ApolloError } from '@apollo/client';

import { type GenerateQSetErrorCode } from '../../types';
interface GenerateQSetErrorDetails {
  details?: {
    code?: GenerateQSetErrorCode;
  };
}

export function getErrorCode(error: unknown) {
  if (!(error instanceof ApolloError)) {
    return null;
  }

  const extensions = error.cause?.extensions;
  if (!extensions || typeof extensions !== 'object' || Array.isArray(extensions)) {
    return null;
  }

  const errorCode = (extensions as GenerateQSetErrorDetails).details?.code;

  if (!errorCode) {
    return null;
  }

  return errorCode;
}
